import { Box, Button, Card, CardContent } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { countries } from "../../../helpers/country-names.js";

export function BillingInfoOverview({ billingInfo, onChange }) {
  const { t, i18n } = useTranslation(["buy", "common"]);
  const locale = i18n.language.substring(0, 2)
  return <Card>
    <CardContent sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ flex: 1 }}>
        <Box>{t(billingInfo.isCompany ? "company" : "personal")}</Box>
        <Box>{billingInfo.name}</Box>
        <Box>{billingInfo.address} - {billingInfo.city} {billingInfo.zipCode} {countries.getName(billingInfo.countryCode, locale) || billingInfo.countryCode}</Box>
        {billingInfo.taxCode && <Box>{billingInfo.taxCode}</Box>}
      </Box>
      <Button onClick={onChange} sx={{ flexShrink: 0 }} variant={"outlined"} size={"small"}>{t("modify")}</Button>
    </CardContent>
  </Card>
}